<script setup lang="ts">
import type { ScaleLinear } from 'd3';

defineProps<{
  loading: boolean;
  yScale: ScaleLinear<number, number, never>;
  numTicks?: number;
  customTicks?: number[];
}>();
</script>
<template>
  <svg class="h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none">
    <template v-if="!loading">
      <!-- Regular tick lines -->
      <g
        v-for="(value, i) in customTicks || yScale.ticks(numTicks || 10)"
        :key="i"
        :transform="`translate(0,${yScale(value)})`"
        class="text-gray-400"
      >
        <line x1="0" x2="100" stroke="currentColor" stroke-dasharray="6,5" stroke-width="0.5" vector-effect="non-scaling-stroke" />
      </g>
    </template>
  </svg>
</template>
